import * as validator from 'validator';
import { z } from 'zod';

const imei = z
  .string()
  .refine((v) => validator.isIMEI(v, { allow_hyphens: true }), {
    message: 'IMEI is not valid',
  });

export const createRouterBody = z.object({
  name: z.string().min(1),
  ipAddress: z.ipv4(),
  imei,
  username: z.string().min(1),
  password: z.string().min(1),
  patientId: z.uuid().optional(),
  cameraIds: z.array(z.uuid()).optional(),
});
export type CreateRouterBody = z.infer<typeof createRouterBody>;

export const updateRouterBody = createRouterBody.extend({
  id: z.uuid(),
});
export type UpdateRouterBody = z.infer<typeof updateRouterBody>;

export const routerIdParam = z.object({ id: z.string().min(1) });
export type RouterIdParam = z.infer<typeof routerIdParam>;
